import gql from "graphql-tag";

export default gql`
  mutation QueryRemoveDataVariable($variableId: uuid!) {
    delete_data_variables(where: { id: { _eq: $variableId } }) {
      affected_rows
    }
  }
`;
